export default __webpack_public_path__ + "static/media/coca-cola.6686be62.png";